import { ThemeUICSSObject } from '@apia/theme';
import primary from './primary';
/* IMPORT HERE */
const noSelection: ThemeUICSSObject = {
  ...primary,
  /* PREPEND HERE */
  '[role="treeitem"][aria-selected="true"] > .tree__nodeItemLabel': {
    background: 'none',
  },
};

export default noSelection;
